import { SafeLink } from "@/components/ui/SafeLink";
import { Button } from "@/components/ui/button";
import { SlideFromLeft, SlideFromRight } from "@/components/ui/animations";

export default function Tiles() {
    return (
        <div className="flex flex-col w-full bg-gradient-to-b from-gray-50 to-gray-100 relative overflow-hidden">
            {/* Background decorative elements */}
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute top-0 left-1/4 w-32 h-32 bg-red-500/3 rounded-full blur-3xl"></div>
                <div className="absolute bottom-1/3 right-1/4 w-48 h-48 bg-gray-900/2 rounded-full blur-3xl"></div>
            </div>

            {/* Kitchen Appliances */}
            <SlideFromLeft Component={
                <div id="kitchen-appliances" className=" lg:px-6 xl:px-12 py-14 relative z-10">
                    <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-10 lg:gap-12 justify-center">
                        <div className="relative group flex-shrink-0 px-4 md:px-6 lg:px-0 transform transition-all duration-700 hover:-translate-y-3 hover:scale-105">
                            <img
                                loading="eager"
                                className="md:w-full lg:max-w-xl xl:max-w-2xl w-full h-full lg:h-72 xl:h-80 object-cover rounded-2xl shadow-lg group-hover:shadow-2xl transition-all duration-700"
                                src={`${process.env.REACT_APP_BLOB_URL}/www/img/NewWebPhotos/Appliances/hnc-web-kitchen-appliances-category.jpg`}
                                alt="Modern kitchen with built-in oven, cooktop, fridge, and dishwasher"
                            />
                            {/* Dark overlay for hover effect */}
                            <div className="absolute inset-0 bg-black/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            {/* Animated shine effect */}
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-2xl"></div>
                        </div>
                        <div className="flex flex-col gap-10 md:gap-8 lg:px-0 px-4 text-center lg:text-left">
                            <div className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 max-w-lg sm:mx-auto md:mx-auto lg:mx-0 leading-tight">
                                <span className="hero-text-gradient-red">Kitchen </span> Appliances
                            </div>
                            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl">
                                Build kitchens that last. Choose ovens, cooktops, dishwashers, and rangehoods from brands you trust. Enjoy trade pricing and project support that keeps timelines on track and quality top of mind.
                            </p>

                        </div>
                    </div>
                </div>
            } />

            {/* Subtle section separator */}
            <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300/50 to-transparent mx-auto"></div>

            {/* Laundry Appliances */}
            <SlideFromRight Component={
                <div id="laundry-appliances" className="md:pl-0 lg:px-6 xl:px-12 py-14 relative z-10">
                    <div className="flex flex-col lg:flex-row-reverse items-center gap-8 md:gap-10 lg:gap-12 justify-center">
                        <div className="relative group flex-shrink-0 px-4 md:px-6 lg:px-0 transform transition-all duration-700 hover:-translate-y-3 hover:scale-105">
                            <img
                                loading="eager"
                                className="md:w-full lg:max-w-xl xl:max-w-2xl w-full h-full lg:h-72 xl:h-80 object-cover rounded-2xl shadow-lg group-hover:shadow-2xl transition-all duration-700"
                                src={`${process.env.REACT_APP_BLOB_URL}/www/img/sector/joinery-kitchen-manufacturing-laundry-appliances.jpg`}
                                alt="Sleek laundry room with front-loading washing machine and dryer"
                            />
                            {/* Dark overlay for hover effect */}
                            <div className="absolute inset-0 bg-black/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            {/* Animated shine effect */}
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-2xl"></div>
                        </div>
                        <div className="flex flex-col gap-10 md:gap-4 lg:px-0 px-4 text-center lg:text-left">
                            <div className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 max-w-lg sm:mx-auto md:mx-auto lg:mx-0 leading-tight">
                                <span className="hero-text-gradient-red">Laundry </span> Appliances
                            </div>
                            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl">
                                Discover residential and commercial-grade washing machines and dryers—engineered for reliability, efficiency, and high-volume use. Our team helps you find the perfect fit for every laundry space.
                            </p>
                        </div>
                    </div>
                </div>
            } />

            {/* Subtle section separator */}
            <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300/50 to-transparent mx-auto"></div>

            {/* Small Appliances */}
            <SlideFromLeft Component={
                <div id="small-appliances" className="md:pl-0 lg:px-6 xl:px-12 py-14 relative z-10">
                    <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-10 lg:gap-12 justify-center">
                        <div className="relative group flex-shrink-0 px-4 md:px-6 lg:px-0 transform transition-all duration-700 hover:-translate-y-3 hover:scale-105">
                            <img
                                loading="eager"
                                className="md:w-full lg:max-w-xl xl:max-w-2xl w-full h-full lg:h-72 xl:h-80 object-cover rounded-2xl shadow-lg group-hover:shadow-2xl transition-all duration-700"
                                src={`${process.env.REACT_APP_BLOB_URL}/www/img/NewWebPhotos/Appliances/hnc-web-smalls.jpg`}
                                alt="Retro-style set of small appliances including kettle, espresso machine, and toaster in green and chrome"
                            />
                            {/* Dark overlay for hover effect */}
                            <div className="absolute inset-0 bg-black/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            {/* Animated shine effect */}
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-2xl"></div>
                        </div>
                        <div className="flex flex-col gap-10 md:gap-4 lg:px-0 px-4 text-center lg:text-left">
                            <div className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 max-w-lg sm:mx-auto md:mx-auto lg:mx-0 leading-tight">
                                <span className="hero-text-gradient-red">Small  </span> Appliances

                            </div>
                            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl">
                                Add instant convenience with coffee machines, microwaves, kettles, vacuums, and more. Smart upgrades for homes, offices, or hospitality—chosen for durability and easy maintenance.
                            </p>
                        </div>
                    </div>
                </div>
            } />

            {/* Subtle section separator */}
            <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300/50 to-transparent mx-auto"></div>

            {/* Heating & Cooling */}
            <SlideFromRight Component={
                <div id="heating-cooling" className="lg:px-6 xl:px-12 py-14 relative z-10">
                    <div className="flex flex-col lg:flex-row-reverse items-center gap-8 md:gap-10 lg:gap-12 justify-center">
                        <div className="relative group flex-shrink-0 px-4 md:px-6 lg:px-0 transform transition-all duration-700 hover:-translate-y-3 hover:scale-105">
                            <img
                                loading="eager"
                                className="md:w-full lg:max-w-xl xl:max-w-2xl w-full h-full lg:h-72 xl:h-80 object-cover rounded-2xl shadow-lg group-hover:shadow-2xl transition-all duration-700"
                                src={`${process.env.REACT_APP_BLOB_URL}/www/img/NewWebPhotos/Appliances/hnc-web-heating-cooling.jpg`}
                                alt="Minimalist living room with wall-mounted air conditioner, sofa and coffee table"
                            />
                            {/* Dark overlay for hover effect */}
                            <div className="absolute inset-0 bg-black/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            {/* Animated shine effect */}
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-2xl"></div>
                        </div>
                        <div className="flex flex-col gap-10 md:gap-4 lg:px-0 px-4 text-center lg:text-left">
                            <div className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 max-w-lg sm:mx-auto md:mx-auto lg:mx-0 leading-tight">
                                <span className="hero-text-gradient-red">Heating </span> & Cooling
                            </div>

                            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl">
                                Stay comfortable in every season with our full range of heat pumps, air conditioners, panel heaters, fireplaces, and outdoor heaters—residential or commercial, all in one place.
                            </p>
                        </div>
                    </div>
                </div>
            } />

            {/* Subtle section separator */}
            <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300/50 to-transparent mx-auto"></div>

            {/* TV & Audio Solutions */}
            <SlideFromLeft Component={
                <div id="tv-audio-solutions" className="lg:px-6 xl:px-12 py-14 relative z-10">
                    <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-10 lg:gap-12 justify-center">
                        <div className="relative group flex-shrink-0 px-4 md:px-6 lg:px-0 transform transition-all duration-700 hover:-translate-y-3 hover:scale-105">
                            <img
                                loading="eager"
                                className="md:w-full lg:max-w-xl xl:max-w-2xl w-full h-full lg:h-72 xl:h-80 object-cover rounded-2xl shadow-lg group-hover:shadow-2xl transition-all duration-700"
                                src={`${process.env.REACT_APP_BLOB_URL}/www/img/NewWebPhotos/Appliances/hnc-web-tv.jpg`}
                                alt="Modern living room with wall-mounted TV and soundbar"
                            />
                            {/* Dark overlay for hover effect */}
                            <div className="absolute inset-0 bg-black/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            {/* Animated shine effect */}
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-2xl"></div>
                        </div>
                        <div className="flex flex-col gap-10 md:gap-4 lg:px-0 px-4 text-center lg:text-left">
                            <div className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 max-w-lg sm:mx-auto md:mx-auto lg:mx-0 leading-tight">
                                <span className="hero-text-gradient-red">TV & Audio </span> Solutions
                            </div>
                            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl">
                                Deliver immersive experiences with advanced TV and audio systems—ideal for living rooms, hotel suites, office lounges, and shared spaces. Impress every guest, every time.
                            </p>
                        </div>
                    </div>
                </div>
            } />

            {/* Subtle section separator */}
            <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300/50 to-transparent mx-auto"></div>

            {/* Outdoor Appliances */}
            <SlideFromRight Component={
                <div id="outdoor-appliances" className="lg:px-6 xl:px-12 py-14 relative z-10">
                    <div className="flex flex-col lg:flex-row-reverse items-center gap-8 md:gap-10 lg:gap-12 justify-center">
                        <div className="relative group flex-shrink-0 px-4 md:px-6 lg:px-0 transform transition-all duration-700 hover:-translate-y-3 hover:scale-105">
                            <img
                                loading="eager"
                                className="md:w-full lg:max-w-xl xl:max-w-2xl w-full h-full lg:h-72 xl:h-80 object-cover rounded-2xl shadow-lg group-hover:shadow-2xl transition-all duration-700"
                                src={`${process.env.REACT_APP_BLOB_URL}/www/img/NewWebPhotos/Appliances/hnc-web-outdoor.jpg`}
                                alt="Outdoor kitchen with built-in grill, bar seating, and lounge area"
                            />
                            {/* Dark overlay for hover effect */}
                            <div className="absolute inset-0 bg-black/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            {/* Animated shine effect */}
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-2xl"></div>
                        </div>
                        <div className="flex flex-col gap-10 md:gap-4 lg:px-0 px-4 text-center lg:text-left">
                            <div className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 max-w-lg sm:mx-auto md:mx-auto lg:mx-0 leading-tight">
                                <span className="hero-text-gradient-red">Outdoor </span> Appliances
                            </div>

                            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl">
                                Bring indoor convenience outdoors with an outdoor kitchen, high-performance grills, pizza ovens, beverage centres, and refrigerators. Entertain in style, create new experiences, and make every outdoor space memorable.
                            </p>
                        </div>
                    </div>
                </div>
            } />



        </div>
    )
}